import { render, staticRenderFns } from "./game_profiles.vue?vue&type=template&id=7196fe5a&scoped=true"
import script from "./game_profiles.vue?vue&type=script&lang=js"
export * from "./game_profiles.vue?vue&type=script&lang=js"
import style0 from "./game_profiles.vue?vue&type=style&index=0&id=7196fe5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196fe5a",
  null
  
)

export default component.exports